import { effectScope, watch } from 'vue'
import { useElementBounding, useWindowSize, breakpointsTailwind } from '@vueuse/core'

const FOOTER_GAP = 84
const TOP_GAP = 8
const GAP = 4
const MAX_HEIGHT = 320

export const vFlipUp = {
  mounted(el) {
    if (typeof window === 'undefined' || window.innerWidth >= breakpointsTailwind.xl) return
    const anchor = el.offsetParent
    if (!anchor) return

    const scope = effectScope()
    scope.run(() => {
      const a = useElementBounding(anchor)
      const { height: viewportHeight } = useWindowSize()

      const reposition = () => {
        if (!el.isConnected) return
        const spaceBelow = viewportHeight.value - FOOTER_GAP - a.bottom.value
        const spaceAbove = a.top.value - TOP_GAP
        const needed = Math.min(el.scrollHeight || MAX_HEIGHT, MAX_HEIGHT)
        const flipUp = spaceBelow < needed && spaceAbove > spaceBelow
        const space = flipUp ? spaceAbove : spaceBelow - GAP

        el.style.position = 'fixed'
        el.style.left = `${a.left.value}px`
        el.style.width = `${a.width.value}px`
        el.style.margin = '0'
        el.style.zIndex = '9999'
        el.style.maxHeight = `${Math.min(MAX_HEIGHT, space)}px`

        if (flipUp) {
          el.style.top = 'auto'
          el.style.bottom = `${viewportHeight.value - a.top.value + GAP}px`
        } else {
          el.style.bottom = 'auto'
          el.style.top = `${a.bottom.value + GAP}px`
        }
      }

      watch([a.top, a.left, a.width, a.bottom, viewportHeight], reposition, {
        immediate: true,
        flush: 'post',
      })
    })

    el.__flipScope = scope
  },

  unmounted(el) {
    el.__flipScope?.stop()
    delete el.__flipScope
  },
}
